<div class="flex mb-6 mt-2 font-sans">
	<p class="my-5 m-auto text-gray-800">Copyright 2021-{new Date().getFullYear()} © Palo Alto Data Group</p>
</div>